import {
    faAlignJustify,
    faAlignLeft,
    faMoneyCheck,
    faShoePrints,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAtendimentoDetalhadoAoCliente } from "../../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import moment from "moment";

interface IKPIAtendimentoClienteProps {
    Atendimento: IAtendimentoDetalhadoAoCliente;
}

export default function KPIAtendimentoCliente(
    props: IKPIAtendimentoClienteProps
) {
    const { Atendimento } = props;

    return (
        <>
            <div className="d-flex align-items-center flex-wrap w-100">
                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faAlignJustify}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">
                            Categoria de Atendimento
                        </span>
                        <span className="font-weight-bolder">
                            <span className="text-dark-50 font-weight-bold"></span>
                            {props.Atendimento.DS_CATEGORIA_ATENDIMENTO}
                        </span>
                    </div>
                </div>
                {Atendimento.DS_SUBCATEGORIA_ATENDIMENTO && (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faAlignLeft}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">Subcategoria</span>
                            <span className="font-weight-bolder">
                                {Atendimento.DS_SUBCATEGORIA_ATENDIMENTO}
                            </span>
                        </div>
                    </div>
                )}
                {Atendimento.CLASSIFICACAO_FINANCEIRA?.DS_CLASSIFICACAO ? (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faMoneyCheck}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">
                                Classificação Financeira
                            </span>
                            <span className="font-weight-bolder">
                                {
                                    Atendimento.CLASSIFICACAO_FINANCEIRA
                                        .DS_CLASSIFICACAO
                                }
                            </span>
                        </div>
                    </div>
                ) : null}

                {Atendimento.DT_VALIDADE ? (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faMoneyCheck}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">
                                Validade da Análise
                            </span>
                            <span className="font-weight-bolder">
                                {moment(Atendimento.DT_VALIDADE).format(
                                    "DD/MM/YYYY"
                                )}
                            </span>
                        </div>
                    </div>
                ) : null}

                {Atendimento.jornadaEtapa?.DS_ETAPA_JORNADA ? (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <i
                                style={{
                                    color: Atendimento.jornadaEtapa
                                        ?.HX_COR_PERFIL_ETAPA_JORNADA,
                                }}
                                className={`${Atendimento.jornadaEtapa?.DS_ICON_PERFIL_ETAPA_JORNADA} icon-2x font-weight-bold`}
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">
                                Jornada da Etapa
                            </span>
                            <span className="font-weight-bolder">
                                <span className="text-dark-50 font-weight-bold"></span>
                                {Atendimento.jornadaEtapa?.DS_ETAPA_JORNADA}
                            </span>
                        </div>
                    </div>
                ) : null}

                {Atendimento.perfilFinanceiro?.DS_PERFIL_FINANCEIRO_CONTA ? (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <i
                                style={{
                                    color: Atendimento.perfilFinanceiro
                                        ?.HX_COR_PERFIL_FINANCEIRO_CONTA,
                                }}
                                className={`${Atendimento.perfilFinanceiro?.DS_ICON_PERFIL_FINANCEIRO_CONTA} icon-2x font-weight-bold`}
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">
                                Perfil Financeiro
                            </span>
                            <span className="font-weight-bolder">
                                {
                                    Atendimento.perfilFinanceiro
                                        ?.DS_PERFIL_FINANCEIRO_CONTA
                                }
                            </span>
                        </div>
                    </div>
                ) : null}

                {Atendimento.tipoConta?.DS_PERFIL_TIPO_CONTA ? (
                    <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                        <span className="mr-4">
                            <i
                                style={{
                                    color: Atendimento.tipoConta
                                        ?.HX_COR_PERFIL_TIPO_CONTA,
                                }}
                                className={`${Atendimento.tipoConta?.DS_ICON_PERFIL_TIPO_CONTA} icon-2x font-weight-bold`}
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-size-sm">Tipo Conta</span>
                            <span className="font-weight-bolder">
                                {Atendimento.tipoConta?.DS_PERFIL_TIPO_CONTA}
                            </span>
                        </div>
                    </div>
                ) : null}

                <div className="d-flex align-items-center flex-lg-fill mr-2 my-1">
                    <span className="mr-4">
                        <FontAwesomeIcon
                            icon={faShoePrints}
                            className="icon-2x text-muted font-weight-bold"
                        />
                    </span>
                    <div className="d-flex flex-column text-dark-75">
                        <span className="font-size-sm">Etapa Atual</span>
                        <span className="font-weight-bolder">
                            {" "}
                            {
                                props.Atendimento
                                    .DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }{" "}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}
